var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTradingPlatform = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.714355 0.676819H2.00011V19.9625H21.2865V21.2483H0.714355V0.676819ZM19.7654 4.67925C19.8308 4.73275 19.885 4.7986 19.9249 4.87306C19.9649 4.94751 19.9897 5.0291 19.9981 5.11317C20.0064 5.19723 19.9981 5.28211 19.9737 5.36297C19.9492 5.44383 19.909 5.51907 19.8555 5.58439L14.0695 12.6558C14.0127 12.7252 13.9419 12.782 13.8618 12.8224C13.7817 12.8628 13.694 12.886 13.6043 12.8905C13.5147 12.8949 13.4252 12.8806 13.3414 12.8484C13.2577 12.8162 13.1816 12.7668 13.1181 12.7034L9.79182 9.37725L5.09108 15.8405C4.98825 15.9713 4.83873 16.0571 4.67396 16.0799C4.50918 16.1027 4.34197 16.0608 4.20747 15.9629C4.07297 15.8651 3.98164 15.7189 3.95268 15.555C3.92372 15.3912 3.95939 15.2226 4.05219 15.0845L9.19522 8.01311C9.24981 7.93791 9.32006 7.87544 9.40111 7.83C9.48217 7.78457 9.57211 7.75724 9.66474 7.74991C9.75738 7.74258 9.8505 7.75541 9.9377 7.78753C10.0249 7.81965 10.1041 7.87029 10.1698 7.93596L13.5244 11.2917L18.8603 4.76925C18.9138 4.70387 18.9796 4.64967 19.0541 4.60976C19.1285 4.56985 19.2101 4.54501 19.2942 4.53665C19.3783 4.52829 19.4632 4.53658 19.544 4.56105C19.6249 4.58552 19.7001 4.62568 19.7654 4.67925Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.714311
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTradingPlatform);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trading_platform.c9bba637f81a3d76e926dbfd5e787016.svg";